/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import LegalDocumentsEditor from 'ui/components/organizations/legal-documents/LegalDocumentsEditor.vue';

const __vue_script__ = {
    name: 'LegalDocuments',

    props: {
        organization: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            canUpdateDocs: false,
            docs: [],
        };
    },

    mounted() {
        this.checkUserCanUpdateDocs();
        this.getDocs();
    },

    methods: {
        async getDocs() {
            try {
                const docs = await this.$services.legal.getLegalDocumentsForOrg(this.organization._id);

                this.docs = docs
                    .map(doc => ({
                        ...doc,
                        previewUrl: this.$services.legal.getDocumentPreviewUrl(doc._id),
                        formattedDate: this.$utils.time.dateToFormat(new Date(doc.last_changed * 1000), 'YYYY-MM-DD HH:mm'),
                    }))
                    .sort((a, b) => a.formattedDate > b.formattedDate ? -1 : 1);
            } catch (err) {
                console.error('[LegalDocuments]: Could not get existing documents', err);
            }
        },

        /** @param {string} [docId] */
        openModal(docId) {
            this.$modal.show(
                LegalDocumentsEditor,
                { docId, orgId: this.organization._id },
                { classes: 'small', height: 'auto' },
                { 'before-close': this.getDocs },
            );
        },

        checkUserCanUpdateDocs() {
            const isSuperAdmin = this.$services.user.isSuperAdmin();
            const hasWritePermission = this.$services.user.hasPermission(
                'org_realms.write_org_members_legal_docs',
                { org_id: this.organization._id },
            );
            this.canUpdateDocs = isSuperAdmin || hasWritePermission;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-documents"},[_c('div',{staticClass:"table-wrapper"},[(_vm.docs.length)?_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('legal_documents.table.title')))]),_c('th'),_c('th',[_vm._v(_vm._s(_vm.$t('legal_documents.table.last_changed')))])])]),_c('tbody',_vm._l((_vm.docs),function(doc){return _c('tr',[_c('td',[(_vm.canUpdateDocs)?_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.openModal(doc._id)}}},[_vm._v(_vm._s(doc.title))]):_c('span',[_vm._v(_vm._s(doc.title))])]),_c('td',[_c('a',{attrs:{"href":doc.previewUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('legal_documents.table.preview')))])]),_c('td',[_vm._v(_vm._s(doc.formattedDate))])])}),0)]):_vm._e()]),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.openModal()}}},[_vm._v(_vm._s(_vm.$t('legal_documents.add_new_doc')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LegalDocuments.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__